import React, { useState, useRef, useEffect } from "react";
import "../css/CuMutiSelectBox.css";
import CuInput from "../../all-patient/components/CuInput"; // Adjust import as necessary

const CuMultiSelectBox = ({
  placeholder = "",
  type = "text",
  options = [],
  required = false,
  loading = false,
  position = "calc(50% + 0px)",
  label,
  renderKey,
  searchable = false,
  disabled = false,
  handleSelectOptions = () => {},
  onChange = () => {}, // Add onChange prop
  capitalize = false, // New capitalize prop
  defaultSelectedItems = [], // New prop for default selected items
}) => {
  // Initialize selectedItems with defaultSelectedItems for prefill
  const [searchInput, setSearchInput] = useState("");
  const [selectedItems, setSelectedItems] = useState(defaultSelectedItems);
  const optionsContainerRef = useRef(null);

  // Pass initial selected items to parent on mount if prefilled
  useEffect(() => {
    if (defaultSelectedItems.length > 0) {
      handleSelectOptions(defaultSelectedItems.map((item) => item.id));
    }
  }, [defaultSelectedItems, handleSelectOptions]);

  // Toggle select/deselect an option
  const handleToggleSelect = (option) => {
    const isAlreadySelected = selectedItems.some(
      (item) => item[renderKey] === option[renderKey]
    );
    const updatedSelectedItems = isAlreadySelected
      ? selectedItems.filter((item) => item[renderKey] !== option[renderKey])
      : [...selectedItems, option];

    setSelectedItems(updatedSelectedItems);

    // Return only IDs to parent
    handleSelectOptions(updatedSelectedItems.map((item) => item.id));
  };

  // Handle search input changes
  const handleSearch = (e) => {
    let inputValue = e.target.value;
    if (capitalize) {
      inputValue = inputValue.toUpperCase();
    }
    setSearchInput(inputValue);
    onChange(inputValue);
  };

  // Filter options based on search if `searchable` is enabled
  const filteredOptions = searchable
    ? options.filter((option) =>
        option[renderKey].toLowerCase().includes(searchInput.toLowerCase())
      )
    : options;

  return (
    <div className="relative">
      <CuInput
        type={type}
        placeholder={placeholder}
        value={searchInput}
        disabled={disabled}
        onChange={handleSearch}
        label={label}
        required={required}
        loading={loading}
        position={position}
      />
      {searchInput.length > 0 && filteredOptions.length > 0 && (
        <div className="cu-multi-select-box-list" ref={optionsContainerRef}>
          {filteredOptions.map((option, idx) => (
            <div className="cu-multi-select-box-list-item" key={idx}>
              <input
                type="checkbox"
                checked={selectedItems.some((item) => item.id === option.id)}
                onChange={() => handleToggleSelect(option)}
              />
              <span>{option[renderKey]}</span>
            </div>
          ))}
        </div>
      )}
      {searchInput.length > 0 && filteredOptions.length === 0 && (
        <div className="cu-multi-select-box-list">
          <div className="cu-multi-select-box-list-item text-gray-400">
            {loading ? "Loading..." : "No Data Found"}
          </div>
        </div>
      )}
    </div>
  );
};

export default CuMultiSelectBox;
